/* ============================================================
   POLICY LOAN CALCULATOR™ — USA COMPATIBILITY WRAPPER

   The USA engine was a 980-line verbatim clone of the Canada engine whose
   ONLY real differences were three narrative strings — yet every math fix
   had to be applied twice and could silently drift. The shared engine now
   lives in `calculationEngine.ts` with those narratives keyed by
   jurisdiction (see JURISDICTION_NARRATIVES); this module preserves the
   historical USA import surface by binding jurisdiction = "usa" on the
   functions that produce narrative text. Everything else re-exports
   unchanged — same math, same types, same behaviour.
   ============================================================ */

export * from "./calculationEngine";

import {
  buildCommitmentPageData as buildCommitmentPageDataCore,
  calculateFamilySystemRecapture as calculateFamilySystemRecaptureCore,
  runCombinedScenario as runCombinedScenarioCore,
  type CombinedScenarioInput,
  type CombinedScenarioResult,
  type CommitmentPageData,
  type FamilySystemRecaptureResult,
} from "./calculationEngine";

export function runCombinedScenario(input: CombinedScenarioInput): CombinedScenarioResult {
  return runCombinedScenarioCore({ ...input, jurisdiction: "usa" });
}

export function calculateFamilySystemRecapture(
  input: Parameters<typeof calculateFamilySystemRecaptureCore>[0],
): FamilySystemRecaptureResult {
  return calculateFamilySystemRecaptureCore(input, "usa");
}

export function buildCommitmentPageData(
  params: Parameters<typeof buildCommitmentPageDataCore>[0],
): CommitmentPageData {
  return buildCommitmentPageDataCore({ ...params, jurisdiction: "usa" });
}
